/**
 * Created by Ivan on 31.07.2024
 */

const StickersPackView = cc.Node.extend({
    ctor: function (packSpine, stickersAmount) {
        this._super();

        const styles = cleverapps.styles.StickersPackView;

        this.setAnchorPoint(0.5, 0.5);
        this.setCascadeOpacityEnabledRecursively(true);
        this.setVisible(false);

        let cardsIcon;
        if (packSpine) {
            cardsIcon = new cleverapps.Spine(bundles.stickers_reward_window.jsons.sticker_pack_json);
            this.createPackAnimations();
        } else {
            cardsIcon = new cc.Sprite(bundles.stickers_reward_window.frames.sticker_pack_png);
            this.setOpacity(0);
            this.setScale(0.6);
        }

        cardsIcon.setLocalZOrder(1000);
        this.cardsIcon = cardsIcon;
        this.addChild(cardsIcon);

        this.setContentSize2(cardsIcon.getContentSize());
        cardsIcon.setAlignment(styles.cards_icon);

        if (styles.stickersAmount) {
            this.stickersAmount = cleverapps.UI.generateOnlyText(`x${stickersAmount}`, cleverapps.styles.FONTS.STICKERS_SOURCE_TEXT);

            cardsIcon.addChild(this.stickersAmount);
            this.stickersAmount.setAlignment(styles.stickersAmount);
        }
    },

    updateStickersAmount: function (amount) {
        if (!amount) {
            this.stickersAmount.removeFromParent(true);
            return;
        }
        if (this.stickersAmount) {
            this.stickersAmount.setString(`x${amount}`);
        }
    },

    createPackAnimations: function () {
        const styles = cleverapps.styles.StickersPackView;

        const lightAnimation = this.lightAnimation = new cleverapps.Spine(bundles.stickers_reward_window.jsons.sticker_pack_light_json);
        lightAnimation.setAlignment(styles.lightAnimation);
        this.addChild(lightAnimation, -1);

        const particlePathAnimation = this.particlePathAnimation = new cleverapps.Spine(bundles.stickers_reward_window.jsons.sticker_pack_particle_track_json);
        particlePathAnimation.setAlignment(styles.lightAnimation);
        this.addChild(particlePathAnimation, 1);

        const particleAnimation = this.particleAnimation = new cleverapps.Spine(bundles.stickers_reward_window.jsons.sticker_pack_particle_json);
        particleAnimation.setAlignment(styles.particle);
        this.addChild(particleAnimation);
    },

    createOpenAction: function () {
        return new cc.Spawn(
            new cc.CallFunc(() => {
                cleverapps.effects.fire("stickers.window.pack.open");
                this.cardsIcon.setAnimation(0, "open", false);
                this.particlePathAnimation.setAnimation(0, "animation", false);

                this.lightAnimation.runAction(new cc.Sequence(
                    new cc.CallFunc(() => {
                        this.lightAnimation.setAnimation(0, "open", false);
                    }),
                    new cc.ScaleTo(0.5, 1, 2),
                    new cc.ScaleTo(0.1, 1, 1)
                ));
            }),
            new cc.DelayTime(0.6)
        );
    },

    createShowAction: function () {
        const position = this.getPosition();
        this.setPosition(this.x, -this.y - this.height);
        this.hidePosition = this.getPosition();

        return new cc.Sequence(
            new cc.Show(),
            new cc.CallFunc(() => {
                this.cardsIcon.setAnimation(0, "idle", true);
            }),
            new cc.CallFunc(() => {
                this.lightAnimation.setAnimation(0, "idle", true);
                this.particleAnimation.setAnimation(0, "animation", true);
            }),
            new cc.MoveTo(0.5, position.x, position.y).easing(cc.easeBackOut())
        );
    },

    createHideAction: function () {
        return new cc.Sequence(
            new cc.MoveTo(0.5, this.hidePosition.x, this.hidePosition.y).easing(cc.easeBackIn()),
            new cc.Hide()
        );
    },

    onTouchInShadow: function () {
        this.runAction(new cc.Sequence(
            this.createOpenAction(),
            this.createHideAction()
        ));
    },

    showAnimation: function (callback) {
        callback = callback || function () {};

        this.runAction(new cc.Sequence(
            this.createShowAction(),
            this.createOpenAction(),
            this.createHideAction(),
            new cc.CallFunc(callback)
        ));
    }
});

cleverapps.styles.StickersPackView = {
    lightAnimation: {
        x: { align: "center" },
        y: { align: "bottom", dy: 70 }
    },

    particle: {
        x: { align: "center" },
        y: { align: "bottom", dy: 120 }
    },

    cards_icon: {
        x: { align: "center" },
        y: { align: "center", dy: -90 }
    },

    stickersAmount: undefined
};